import {
	getCookie,
	setCookie,
	delCookie
} from '@/utils/cookie'
import * as types from '../mutation-types'
import {
	delData
} from '@/http'
import router from '../../router'
import {
	Message
} from 'element-ui'
let timer = null
export default {
	state: {
		access_token: getCookie('access_token'),
		refresh_token: getCookie('refresh_token'),
		user_permissions: undefined, //用户权限id列表
		activeIndex: '/'
	},
	mutations: {
		//设置用户权限
		setUserPermissions(state, payload) {
			state.user_permissions = payload
			sessionStorage.setItem('user_permissions', JSON.stringify(payload))
		},
		[types.SET_LOGIN_TOKEN](state, payload) {
			setCookie('access_token', payload.access_token, payload.expires_in, 1 * 24 * 60 * 60) //存储一天
			//自定义access_token_validation,其值与access_token一致，是用于判定是否是从后台网站登录的
			setCookie('access_token_validation', payload.access_token, payload.expires_in)
			setCookie('refresh_token', payload.refresh_token)
			state.access_token = payload.access_token
			state.refresh_token = payload.refresh_token
		},
		[types.DELETE_TOKEN](state) {
			// whether success or not, send a request
			delCookie('access_token')
			delCookie('access_token_validation')
			delCookie('refresh_token')
			state.access_token = ''
			state.access_token_validation = ''
			state.refresh_token = ''
		},
		[types.SET_ACTIVE_INDEX](state, index) {
			state.activeIndex = index
		}
	},
	actions: {
		deleteLoginStatus({
			commit,
			state
		}) {
			delData('authorizations/current', {
					Authorization: state.access_token
				})
				.finally(() => {
					commit('DELETE_TOKEN')
					state.user_permissions = undefined //删除当前用户权限
					sessionStorage.removeItem('user_permissions') //删除当前用户权限缓存
					sessionStorage.removeItem('editableTabs') //删除标签页缓存
					sessionStorage.removeItem('editableTabsValue') //删除当前选择标签页缓存
					router.push({
						path: '/login'
					})
					if (timer) {
						return
					}
					timer = setTimeout(() => {
						//防止弹出多次退出提示
						Message.error("已退出登录");
						clearTimeout(timer)
						timer = null
					}, 1000)
				})
		}
	}
}
